import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Checkup from "../components/checkup"
import AiCarousel from "../components/AiCarousel"
import rightArrow from "../assets/img/right-arrow.png"
import checkModal from "../assets/img/check-modal.png"
import ai1 from "../assets/img/generetavi_01.webp"
import ai2 from "../assets/img/ai-3.webp"
import ai3 from "../assets/img/ai-4.webp"
import ai4 from "../assets/img/ai-2.png"

class AiStudio extends Component {
  constructor(props) {
    super(props)
    this.state = {
      display: false,
      value: "",
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    e.preventDefault()
    this.setState({ value: e.target.value })
  }

  showModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.add("active-modal")
  }

  closeModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.remove("active-modal")
  }

  handleSubmit(e) {
    e.preventDefault()
    const title = document.title.split("|", 1).toString()
    const response = fetch("https://forms.flatart.com.tr/index.php?r=app%2Ff&id=7", {
      method: "POST",
      body: JSON.stringify({
        text_327649: title,
        text_204202: document.querySelector("#site").value,
        text_775908: document.querySelector("#name").value,
        text_532192: document.querySelector("#email").value,
      }),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    })
    response.then(res => {
      if (res.status === 200) {
        document.querySelector(".status").innerHTML = "Your message has been sent successfully."
      } else {
        document.querySelector(".status").innerHTML = "An error occurred."
      }
    })
  }

  render() {
    return (
      <Layout>
        <SEO
          title="Flatart AI Studio | AI-Powered Digital Solutions"
          description="Flatart AI Studio integrates AI technologies into your business processes. Generative AI consulting, GEO, UGC/AGC solutions and AI Meetup events."
        />

        <div className="seo-service gads container">
          <div className="baslik-ai" style={{ display: "none" }}>
            <h1 className="h1-ai-h1">What is Flatart AI Studio?</h1>
          </div>

          <div className="row labst ai" style={{ display: "none" }}>
            <AiCarousel />
          </div>

          <div className="row">
            <div className="ai-ort uptade">
              <h2 className="h2-ai-h2">AI-powered transformation solutions for your business</h2>
              <p className="ai-p">
                Flatart AI Studio is an innovation hub that tailors AI technologies to businesses' specific needs. Through Generative AI consulting, GEO - AEO, content optimization (AGC), user-generated content (UGC) solutions, and community meetups, it enables you to integrate AI into your business processes.
              </p>
            </div>
          </div>

          <div className="row ai-border" id="generative-ai-consulting">
            <div className="col-md-6 d-flex align-items-center">
              <div className="lab-flex padding">
                <span className="top-text-ai">— Analysis</span>
                <h3 className="lab-h3 bottom">
                  Generative AI<br />Consulting
                </h3>
                <p className="lab-p">
                  Transform your business processes with AI-powered solutions. Add value to your business with chatbots, content generation, and automation solutions.
                </p>
                <a className="ai-a" href="/ai-consulting/">Learn more</a>
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="image-container ai">
                <img className="lab-one-lab" alt="Generative AI Consulting" src={ai1} loading="lazy" />
              </div>
            </div>
          </div>

          <div className="row ai-border mt-3 reverse-mobile" id="answer-engine-optimization">
            <div className="col-md-6 d-flex align-items-center">
              <div className="image-container ai">
                <img className="lab-one-lab" alt="GEO - Generative Engine Optimization" src={ai4} loading="lazy" />
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="lab-flex left uptade">
                <span className="top-text-ai">— Access</span>
                <h3 className="lab-h3 bottom">
                  GEO (Generative Engine<br />Optimization)
                </h3>
                <p className="lab-p">
                  Flatart AI Studio makes brands' content more suitable for AI-powered search engines. GEO increases your website's visibility and strengthens user experience.
                </p>
                <a className="ai-a" href="/geo/">Get in touch</a>
              </div>
            </div>
          </div>

          <div className="row ai-border mt-3" id="ugc-agc-solutions">
            <div className="col-md-6 d-flex align-items-center">
              <div className="lab-flex padding">
                <span className="top-text-ai">— Conversion</span>
                <h3 className="lab-h3 bottom">
                  UGC &amp; AGC Solutions
                </h3>
                <p className="lab-p">
                  We strengthen brands' digital presence with user-generated content (UGC) and AI-generated content (AGC). We enrich your social media, campaign, and ad processes with AI-powered content.
                </p>
                <a className="ai-a" href="/contact/">Get in touch</a>
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="image-container ai">
                <img className="lab-one-lab" alt="UGC and AGC Solutions" src={ai2} loading="lazy" />
              </div>
            </div>
          </div>

          <div className="row ai-border mt-3 reverse-mobile" id="ai-meetup">
            <div className="col-md-6 d-flex align-items-center">
              <div className="image-container ai">
                <img className="lab-one-lab" alt="AI Meetup Events" src={ai3} loading="lazy" />
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="lab-flex left uptade">
                <span className="top-text-ai">— Growth</span>
                <h3 className="lab-h3 bottom">
                  AI Meetup Events
                </h3>
                <p className="lab-p">
                  Meet AI communities! Flatart AI Studio brings together brands, startups, and technology enthusiasts through its AI Meetup events. Move your business into the future through experience sharing, networking, and industry knowledge transfer.
                </p>
                <a className="ai-a" href="/contact/">Get in touch</a>
              </div>
            </div>
          </div>

          <div className="client-lab-btn">
            <a className="red-button black" href="/contact/">Let's Meet</a>
            <button className="red-button" onClick={() => this.showModal()}>
              Get your special offer <img className="lab-right" src={rightArrow} alt="" />
            </button>
          </div>

          <div className="check-modal">
            <span onClick={() => this.closeModal()}>X</span>
            <h2 className="form-head">Fill the form.</h2>
            <p className="form-desc">Enter your information in the fields to get information, and we will get back to you as soon as possible.</p>
            <div className="check-modal_container">
              <form onSubmit={e => this.handleSubmit(e)}>
                <input type="text" name="text_204202" id="site" required placeholder="Enter your website." />
                <input type="text" id="name" required name="text_775908" placeholder="Enter your name." />
                <input type="email" id="email" required name="text_532192" value={this.state.value} onChange={this.handleChange} autoFocus={true} placeholder="Enter your email address." />
                <button>SEND</button>
                <div className="status"></div>
              </form>
              <img alt="" src={checkModal} />
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default AiStudio
